<div class="productos-container">
  <div class="header-actions">
    <h1>Catálogo de Productos</h1>

    <!-- Añade este campo de búsqueda -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar productos</mat-label>
      <input matInput
             [(ngModel)]="searchTerm"
             (keyup)="onSearch()"
             placeholder="Código, nombre o etiquetas...">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <button mat-raised-button color="primary"
            (click)="abrirDialogoProducto()"
            aria-label="Agregar nuevo producto">
      <mat-icon>add</mat-icon> Nuevo Producto
    </button>
  </div>

  <div class="filter-row">
    <span class="filter-label">Tipo de producto:</span>
    <mat-button-toggle-group [value]="tipoProductoSeleccionado" (change)="filtrarPorTipo($event.value)">
      <mat-button-toggle *ngFor="let t of tiposProductoFiltro" [value]="t.value">
        {{ t.label }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <ng-container *ngIf="(error$ | async) as error; else tableTemplate">
    <div class="error-state">
      <mat-icon>error_outline</mat-icon>
      <p>No se pudieron cargar los productos. Intente nuevamente.</p>
    </div>
  </ng-container>

  <ng-template #tableTemplate>
    <app-table-generic
      [config]="(tableConfig$ | async) || { columns: [] }"
      [data]="(data$ | async) || []"
      [activarBusqueda]="false"
      [totalItems]="(totalItems$ | async) || 0"
      [loading]="(loading$ | async) || false"
      [dialogComponent]="dialogComponent"
      [serverSide]="true"
      [pageIndexInput]="currentPageIndex"
      [pageSizeInput]="currentPageSize"
      [canEdit]="false"
      [canDelete]="false"
      (editClick)="onEdit($event)"
      (deleteClick)="onDelete($event)"
      (detailsClick)="onViewDetails($event)"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)">
    </app-table-generic>
  </ng-template>
</div>
